var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:['text-btn', { 'text-btn--small': _vm.small }],attrs:{"text":""},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.right)?_c('v-icon',{style:({
      fontSize: _vm.size ? _vm.size : null,
    })},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._t("default"),(_vm.right)?_c('v-icon',{style:({
      fontSize: _vm.size ? _vm.size : null,
    })},[_vm._v(_vm._s(_vm.icon))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }